<template>
  <div id="app">
      <header>
            <div class="container-fluid top-menu">
                <div class="container py-2">
                    <div class="row">
                        <div class="col-xl-3 col-lg-4 col-sm-8 header-logo">
                          <router-link to="/" class="logo-text" id="top"><img src="../src/assets/images/drandrewslogo.png"></router-link>
                        </div>
                        <a href="#" class=".d-xl-none burger-menu" v-on:click="show = !show">
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24">
                            <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"/>
                          </svg>
                        </a>
                        <div class=" col-xl-9 col-lg-12 navigation" v-bind:class="{' mobile-menu' : show}">
                          <ul class="header-nav-items menu">
                              <li>
                                  <router-link to="/my-services" class="header-nav-link">My Services</router-link>
                              </li>
                              <li>
                                  <router-link to="/my-offices" class="header-nav-link">My Offices</router-link>
                              </li>
                              <li>
                                  <a href="/#testimonials" class="header-nav-link">Testimonials</a>
                              </li>
                              <li>
                                  <router-link to="/contact" class="header-nav-link">Contact</router-link>
                              </li>
                              <li class="img-nav-link">
                                  <a href="tel:01276857090" onclick="gtag('event', 'Number', { 'event_category': 'Phone', 'event_label': 'Clicked' });"><img src="../src/assets/images/phone.png"></a>
                              </li>
                              <li class="img-nav-link">
                                  <a href="mailto:info@drandrewsoffice.co.uk" onclick="gtag('event', 'Clicked', { 'event_category': 'Email', 'event_label': 'Complete' });"><img src="../src/assets/images/email.png"></a>
                              </li>
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <router-view/>
        <footer>
            <div class="container-fluid bg">
                <div class="container footer-content">
                    <div class="row">
                        <div class="col-lg-9">
                            <p>Copyright &copy; Dr Gilbert Andrews. All Rights Reserved.</p>
                            <p>Full Registration with GMC: 1723030 |  Fellow of the Royal College of Psychiatrists (1994)</p>
                        </div>
                        <div class="col-lg-12 col-md-6">
                            <ul class="footer-nav">
                                <li class="footer-nav-item"><router-link to="/my-services#top">My Services</router-link></li>
                                <li class="footer-nav-item"><router-link to="/my-offices#top">My Offices</router-link></li>
                                <li class="footer-nav-item"><router-link to="/contact#top">Contact</router-link></li>
                                <li class="footer-nav-item"><router-link to="/terms-of-business#top">Terms of Business</router-link></li>
                                <li class="footer-nav-item"><router-link to="/website-terms-and-conditions#top">Website Terms and Conditions</router-link></li>
                                <li class="footer-nav-item"><router-link to="/privacy-policy#top">Privacy Policy</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      show: true
    }
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Tinos:400,700');
  @import "../node_modules/bootstrap/scss/bootstrap.scss";
  @import "../src/assets/styles/bootstrap.scss";
  @import "../src/assets/styles/main.scss";
  body{
      margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue